var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 917,
    width: 128,
    height: 129
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-585 -917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.267 63.8667C103.867 63.8667 103.333 63.8667 102.933 63.8667 102.933 63.8667 102.933 63.8667 102.933 63.8667 102.933 57.3333 99.7333 51.3333 94.5333 47.6 89.2 43.8667 82.4 42.9333 76.2667 45.0667 71.2 35.2 60 30.1333 49.3333 32.6667 38.6667 35.2 30.9333 44.8 30.9333 55.8667 30.9333 55.8667 30.9333 56 30.9333 56.1333 23.6 54.9333 16.2667 58 11.7333 63.8667 7.33333 69.8667 6.53333 77.7333 9.6 84.4 12.8 91.0667 19.4667 95.4667 26.8 95.8667L26.8 96 104.133 96C112.933 96 120.133 88.8 120.133 80 120.133 71.2 113.067 63.8667 104.267 63.8667Z",
    transform: "matrix(1 0 0 1.00781 585 917)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloudIcon.9b5175f9ef5b1e334e8a550827d5400d.svg";
export { ForwardRef as ReactComponent };